module.exports = __webpack_public_path__ + "assets/img/zf3.c761ec6f.png";